import type {ComponentFeature} from '@wix/document-services-types'
import {COMPONENT_FEATURES} from '@wix/format-converter-schemas'
import type {InnerElementContext} from '../types'

/**
 * Pack transformation for innerElement queries
 * Converts query properties to namespace properties (e.g., dataQuery → data, styleId → style)
 */
export const packInnerElementQueries = ({element}: InnerElementContext): void => {
    for (const feature of Object.values(COMPONENT_FEATURES) as ComponentFeature[]) {
        const {query, alias} = feature

        if (query in element) {
            element[alias] = element[query]
            delete element[query]
        }
    }
}

/**
 * Unpack transformation for innerElement namespaces
 * Converts namespace properties back to query properties (e.g., data → dataQuery, style → styleId)
 */
export const unpackInnerElementQueries = ({element}: InnerElementContext): void => {
    for (const feature of Object.values(COMPONENT_FEATURES) as ComponentFeature[]) {
        const {query, alias} = feature

        if (alias in element) {
            element[query] = element[alias]
            delete element[alias]
        }
    }
}
